module.exports = __webpack_public_path__ + "media/images/Divorcee-Matrimony-in-Canada-c31d876f0c7817b38c1d892969d09f0e.jpg";